import React from 'react'
import styled from 'styled-components'
import Kara from '../img/kara-1040.jpg'
const DivMenu = styled.div`
  width: 100%;
  font-size: 1.5rem;
  p {
    font-size: 1rem;
  }
`
const TabTitle = styled.div`
  font-size: 1.5rem;
  margin-top: 1rem;
  span {
    color: red;
    font-size: 1.5rem;
  }
`
const ImgLogo = styled.img`
  margin-bottom: 1rem;
  width: 300px;
`

const FromFinish = props => {
  return (
    <DivMenu>
      <TabTitle>ลงทะเบียนเสร็จสิ้น</TabTitle>
      <ImgLogo src={Kara} alt="logo" />
      <p>
        คุณได้รับสิทธิ์แลกซื้อไก่คารา คารา ชิคเก้น <br />
        (มูลค่า 80 บาท) ในราคาเพียง 1 บาท
        <br />
        <br />
        กรุณาแสดงหน้านี้กับพนักงานเพื่อรับสิทธิ์
      </p>
      <p>
        <i> * สิทธิพิเศษนี้ เฉพาะการสั่งทานในร้านเท่านั้น</i>
      </p>
      <p>
        <i>
          {' '}
          ** สิทธิพิเศษนี้ สำหรับลูกค้าที่ลงทะเบียนหน้าร้านเท่านั้น
          ไม่รับการแสดงสิทธิ์ผ่านการบันทึกหน้าจอ
        </i>
      </p>
    </DivMenu>
  )
}
export default FromFinish
